import { OrderMarker, OrderStatusFilterGroups } from '@/Enums';
import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { changePaymentAsyncActions } from '@/ModalWindows/ChangePaymentStatusModal/services/asyncActions';
import { AppDispatch } from '@/Redux/ConfigureStore';
import { salesPageActions } from '@/Pages/Sales/services';
import { purchasesPageAsyncActions } from '@/Pages/Purchases/services';

export const useAllPaidForm = (orderIds: number[], isSalesPage: boolean, onClose: () => void) => {
  const dispatch: AppDispatch = useDispatch();

  const submit = useCallback(() => {
    dispatch(
      changePaymentAsyncActions.changePaymentStatus({
        orderIds,
        orderMarker: OrderMarker.NotPaid,
      }),
    ).then(() => {
      if (isSalesPage) {
        dispatch(
          salesPageActions.removeOrdersFromStateByCurrentFilters({
            orderIds: orderIds,
            filters: OrderStatusFilterGroups.NotShippedGroup,
          }),
        );
      } else {
        dispatch(purchasesPageAsyncActions.getPurchasesWithCurrentFilters());
      }

      onClose();
    });
  }, [onClose, orderIds, isSalesPage]);

  return {
    submit,
  };
};
